import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import ViewModule from "@mui/icons-material/ViewModule";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import type { ToggleButtonGroupProps } from "@mui/material";
import type { FC } from "react";

export type ViewMode = "grid" | "list";

type ViewToggleProps = {
  value: ViewMode;
  onChange: (view: ViewMode) => void;
} & Omit<ToggleButtonGroupProps, "value" | "onChange">;

export const ViewToggle: FC<ViewToggleProps> = ({ value, onChange, ...props }) => {
  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: ViewMode): void => {
    onChange(newValue);
    event.preventDefault();
  };

  return (
    <ToggleButtonGroup value={value} onChange={handleChange} exclusive color="primary" {...props}>
      <ToggleButton data-analytics-id="tabbed-programs-toggle-grid" value="grid" title="Grid view">
        <ViewModule />
      </ToggleButton>
      <ToggleButton data-analytics-id="tabbed-programs-toggle-list" value="list" title="List view">
        <FormatListBulleted />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
